import { Component } from "@kluntje/core";
import {find} from "@kluntje/js-utils/lib/dom-helpers";

/**
 * Custom Element to resize iframe size when iframe content changed
 */
class FRAIframe extends Component {
  constructor() {
    super({
      ui: {
        iframe: ".fra-e-iframe iframe",
      },
    });
  }

  /**
   * @override
   */
  afterComponentRender() {
    // this.checkIframeSize();
    if (window.addEventListener) {
      window.removeEventListener("message", event => {
        this.handleContentSizeChange(event);
      });
      window.addEventListener("message", event => {
        this.handleContentSizeChange(event);
      });
    }
  }

  // potentially enable in future if iframe resizing is needed for internal sources
  checkIframeSize() {
    const iframeObj: HTMLIFrameElement | null = [...this.ui.iframe][0];
    if (iframeObj && iframeObj.contentWindow) {
      const style = iframeObj.contentWindow.getComputedStyle(iframeObj.contentWindow.document.documentElement);
      const height = parseInt(style.getPropertyValue("height"), 10);
      const wrapper: HTMLElement | null = iframeObj.closest(".fra-m-iframe");
      if (wrapper) {
        wrapper.style.height = `${height}px`;
      }
    }
    setTimeout(() => this.checkIframeSize(), 2000);
  }

  handleContentSizeChange(e: MessageEvent) {
    if (e.data.event === "contentSizeChanged" && e.data.height) {
      const iframeObj: HTMLIFrameElement | null = find(this, "iframe") as HTMLIFrameElement | null;
      if (iframeObj) {
        iframeObj.height = e.data.height;
        const wrapper: HTMLElement | null = iframeObj.closest(".fra-m-iframe");
        if (wrapper) {
          wrapper.style.height = `${e.data.height + 60}px`;
        }
      }
    }
  }
}

customElements.define("fra-e-iframe", FRAIframe);

export default FRAIframe;
